import { SiteLink } from "shared/components/SiteLink";
import { LANDING_TYPE } from "clariah/utils/constants";
import { PLAY_VIDEO, translate } from "shared/utils/translate";
import { PlayIcon } from "shared/components/Icons";
import { SrcSet } from "shared/components/SrcSet";
import { useRouter } from "next/router";
import { useState } from "react";
import { AutoplayVideo } from "shared/components/Video";
import { Highlight } from "./Highlight";
import styles from "./HomeHero.module.css";

export const HomeHero = ({ image, links, intro, video, highlight }) => {
  const { locale } = useRouter();
  const [videoPlaying, setVideoPlaying] = useState(false);

  return (
    <div className={styles.hero}>
      <div className={styles.mainWrapper}>
        <div className={styles.maxWidth}>
          <div className={styles.content}>
            {highlight &&
              highlight.href &&
              highlight.title &&
              highlight.text &&
              highlight.thumbnail && (
                <div className={styles.highlightWrapper}>
                  <Highlight {...highlight} />
                </div>
              )}
            <ul className={styles.linksList}>
              {(links || []).map(({ title, slug }, i) => (
                <li key={title} className={styles.linksListItem}>
                  <SiteLink type={LANDING_TYPE} href={slug?.current}>
                    {title}
                  </SiteLink>
                </li>
              ))}
            </ul>
            <p className={styles.intro}>{intro}</p>
          </div>
        </div>
        <div className={styles.logoWrapper}>
          <BackgroundSvg />
        </div>
        <div className={styles.cornerWrapper}>
          <BottomCornerSvg />
        </div>
      </div>

      {(image || video) && (
        <div className={styles.mediaWrapper}>
          <div className={styles.maxWidth}>
            <div className={styles.mediaWrapperInner}>
              {image && image.url && (
                <div className={styles.imageWrapper}>
                  <SrcSet
                    alt={image.alt}
                    sizes={[
                      { minWidth: 800, width: 860, ratio: 16 / 9 },
                      { minWidth: 700, width: 800, ratio: 16 / 9 },
                      { minWidth: 600, width: 700, ratio: 16 / 9 },
                      { minWidth: 500, width: 600, ratio: 16 / 9 },
                      { minWidth: 400, width: 500, ratio: 16 / 9 },
                      { minWidth: 1, width: 400, ratio: 16 / 9 },
                    ]}
                    src={image.url}
                  />
                </div>
              )}

              {video && video.id && image && image.url && !videoPlaying && (
                <button
                  type="button"
                  className={styles.playButton}
                  onClick={() => setVideoPlaying(true)}
                  aria-label={translate(PLAY_VIDEO, locale)}
                >
                  <span className={styles.playButtonCircle}>
                    <PlayIcon />
                  </span>
                </button>
              )}

              {video &&
                video.id &&
                video.type &&
                (videoPlaying || !image || !image.url) && (
                  <div className={styles.videoWrapper}>
                    <AutoplayVideo id={video.id} type={video.type} />
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const BackgroundSvg = () => (
  <svg
    viewBox="0 0 413 826"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMaxYMid meet"
  >
    <path
      opacity=".67"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 582.438l413-243.563V0L0 243.562v338.876z"
      fill="#2350FF"
    />
    <path
      opacity=".33"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M413 825.997L0 582.435V243.56l413 243.562v338.875z"
      fill="#2350FF"
    />
  </svg>
);

const BottomCornerSvg = () => (
  <svg viewBox="0 0 320 188" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".66"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M320 188H0V0l320 188z"
      fill="#2350FF"
    />
  </svg>
);
